import React, { useEffect, useState } from 'react';
import MessageBox from '../components/MessageBox';
import LoadingBox from '../components/LoadingBox';
import { register } from '../actions/adminActions';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ADMIN_REGISTER_RESET } from '../constants/adminConstants';

export default function CreateAdmin(props){
    const adminSignin = useSelector((state) => state.adminSignin);
    const { adminInfo } = adminSignin;
    const adminRegister = useSelector((state) => state.adminRegister); 
    const { adminReg, loading, error } = adminRegister;
    const [admin, setAdmin] =useState(
        {
            name: '',
            password: '',
            rePassword: '',
            role_admin: false,
            role_edit: false,
            role_view: false,
        }
    );

    const dispatch = useDispatch();
    const navigate = useNavigate();
    function updateData(type, newData){    // used for updating datas related to options in select
        setAdmin((admin) =>{
          return {...admin, [type]: newData}
        }); 
    }

    const submitRegister = (e) => {
        // TO DO User type/role
        e.preventDefault();
        dispatch(register(admin));
      };

    useEffect(()=> {
        if(!adminInfo){
            navigate("/signin");
        }
    },[adminInfo,navigate]);

    useEffect(()=>{
        dispatch({type: ADMIN_REGISTER_RESET});
    },[]);

    return(
        <div className="row">
            <form className="form col-lg-4 col-md-4 col-sm-12 col-xs-12 mt-10 pt-10 "  onSubmit={submitRegister}>
                <div className="form-setup">
                { adminInfo?.role_admin ?
                    <div className="form-input">
                    <div>
                        <p > Welcome to Admin panel</p>
                        <h1>Create an admin </h1>
                        {loading ? <LoadingBox /> : <></>}
                        {error? <MessageBox danger="danger">{error} </MessageBox> : <></>}
                        {adminReg ? <MessageBox > { 'Admin created successfully.'} </MessageBox> : <></>}
                    <div className="input-login">
                        <input type="name" id="name"  required onChange={(e) => updateData('name',e.target.value)} ></input>
                        <label htmlFor="name"> Name </label>
                    </div>
                    <div className="input-login">
                        <input type="password" id="password"  required onChange={(e) => updateData('password',e.target.value)} ></input>
                        <label htmlFor="password"> Password </label>
                    </div>
                    <div className="input-login">
                        <input type="password" id="rePassword"  required onChange={(e) => updateData('rePassword',e.target.value)} ></input>
                        <label htmlFor="rePassword"> Password Confirmation </label>
                    </div>
                    <div className="input-check">
                        <input type="checkbox" id="adminRole"  checked={admin.role_admin} onChange={(e) => updateData('role_admin',e.target.checked)} ></input>
                        <label htmlFor="adminRole"> Admin Role </label>
                    </div>
                    <div className="input-check">
                        <input type="checkbox" id="editRole" checked={admin.role_edit}  onChange={(e) => updateData('role_edit',e.target.checked)} ></input>
                        <label htmlFor="editRole"> Edit Role </label>
                    </div>
                    <div className="input-check">
                        <input type="checkbox" id="viewRole" checked={admin.role_view}  onChange={(e) => updateData('role_view',e.target.checked)} ></input>
                        <label htmlFor="viewRole"> View Role </label>
                    </div>
                    <div className="button">
                        <button className="primary" type="submit" id="button"> Create </button>
                    </div>
                </div>
                    </div>
                : <MessageBox danger="danger">{{error: "Access denied, you are not authorized."}}</MessageBox> 
            }
                </div>
            </form>
        </div>
    );
}